<template>
  <div class="flex container">
    <va-button class="alignright" color="gray" @click="createReport">
      Create Report
    </va-button>
    <va-modal v-model="showCreateReportModal" overlay-opacity="0.2" size="medium" hide-default-actions blur>
      <template #header>
        <h2>New Report</h2>
      </template>
      <EditReportModal @close="close" />
    </va-modal>
    <hr />
    <va-data-table class="report-list" :items="reports" :columns="columns" striped :per-page="perPage"
      :current-page="currentPage" animated=true no-data-html="No reports available" :style="{
        'font-size': '14px',
        'font-family': 'Proxima',
        'font-weight': 'bold',
        '--va-data-table-thead-font-size': '.9rem'
      }">
      <template v-slot:actions="props">
        <va-button small color="gray" @click="update(props.rowData)">
          Update
        </va-button>
        <va-button small color="gray" @click="remove(props.rowData)">
          Delete
        </va-button>
      </template>
      <template #cell(actions)="{ rowIndex }">
        <va-button flat icon="edit" color="gray" @click="update(rowIndex)" />
        <va-button flat icon="delete" color="gray" @click="remove(rowIndex)" />
      </template>
      <template #bodyAppend>
        <tr>
          <td colspan="8" class="reports--pagination">
            <va-pagination v-model="currentPage" :pages="pages" hide-on-single-page />
          </td>
        </tr>
      </template>
    </va-data-table>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { mapState, mapActions } from "vuex";
import EditReportModal from '@/modules/admin/components/EditReportModal'

export default {
  name: "report-management",
  components: {
    EditReportModal
  },
  props: {},
  data() {
    const reports = [];

    const columns = [
      { key: 'name', title: 'Display name', sortable: true, width: '10%' },
      { key: 'workspace_id', title: 'Workspace Id', sortable: true, width: '18%' },
      { key: 'report_id', title: 'Report Id', sortable: true, width: '18%' },
      { key: 'permission__name', title: 'Permission', sortable: true, width: '10%' },
      { key: 'category__name', title: 'Category', sortable: true, width: '10%' },
      { key: 'enable_RLS', title: 'CONTENT FILTERING', sortable: true, width: '2%' },
      { key: 'actions', dataClass: 'text-right' }
    ];
    const additionalStyle = {
      color: "white",
      fontWeight: 900
    };
    return {
      columns,
      additionalStyle,
      showCreateReportModal: false,
      currentPage: 1,
      perPage: 5,
      filter: '',
      filtered: reports
    }
  },
  computed: {
    ...mapState({
      reports: state => state.admin.adminReportList ? state.admin.adminReportList.reports : [],
      selectedEntity: state => state.user.selectedEntity,
      pages() {
        return (this.perPage && this.perPage !== 0)
          ? Math.ceil(this.reports.length / this.perPage)
          : this.reports.length
      }
    })
  },
  methods: {
    ...mapActions({
      getAdminReportList: 'admin/getAdminReportList'
    }),
    update(index) {
      this.$emit("openEditReportModal", { report: this.reports[index], operation: 'Edit' });
    },
    remove(index) {
      if (confirm('Are you sure you want to delete the report?')) {
        const report = this.reports[index];
        const param = {
          id: report.id,
          name: report.name,
          workspaceId: report.workspace_id,
          reportId: report.report_id,
          entityId: this.selectedEntity ? this.selectedEntity.id : 0,
          permissionId: report.permission_id,
          categoryId: report.category_id,
          isActive: 0
        };
        this.$emit("removeReport", { report: param, operation: 'Delete' });
      }

    },
    close() {
      this.showCreateReportModal = false
    },
    createReport() {
      // this.$emit("openEditReportModal", {operation:'New'});
      this.showCreateReportModal = !this.showCreateReportModal;

    }
  },
  mounted() {
    if (this.selectedEntity) {
      this.getAdminReportList({ entityId: this.selectedEntity.id })
    }
  }
}
</script>

<style lang="scss" scoped>
.reports--pagination {
  text-align: center;
  text-align: -webkit-center;
}

span {
  text-transform: none !important;
}

.container {
  padding: 0.75rem;
  padding-top: 1rem;
  color: black;
  background: white;
  border-radius: 0.375rem;
  box-shadow: 0px 0px 24px 5px #000;
  -moz-box-shadow: 0px 0px 24px 5px #000;
  -webkit-box-shadow: 0px 0px 24px 5px #000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  & .reportTable {
    width: 100%;
  }
}

.alignright {
  float: right;
}

.report-list {}

table.va-data-table {
  background: #000 !important;
}
</style>